import defaultState from "./state";

const detalleSolicitudSRReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "CARGAR_DETALLE_SOLICITUD": {
      return Object.assign({}, state, {
        prestaciones: action.prestaciones,
      });
    }

    case "CARGAR_DETALLE_SOLICITUD_PAQUETE": {
      return Object.assign({}, state, {
        prestaciones: action.prestaciones[0],
        prestaciones2: action.prestaciones[1],
        prestaciones3: action.prestaciones[2],
      });
    }

    case "CARGAR_DETALLE_SOLICITUD_CABECERA": {
      return Object.assign({}, state, {
        fechaSolicitud: action.solicitud.FechaCreacion,
        tipoSolicitud: action.solicitud.TipoSolicitud,
        estadoSolicitud: action.solicitud.EstadoSolicitud,
        fechaResolucion: action.solicitud.FechaResolucionConvenio,
      });
    }

    case "LOADINGFILE": {
      return Object.assign({}, state, {
        loadingFile: action.loadingFile
      })
    }

    default:
      return state;
  }
};

export default detalleSolicitudSRReducer;



// WEBPACK FOOTER //
// ./src/components/SolicitudesRealizadas/DetalleSolicitud/reducer.js